// client/src/features/equipment/enums.ts — the wire enum SCR-EQP-001/002 render · MAINT-006.
//
// GENERATED union (`@/client`), declared `as const satisfies readonly T[]` — the shape
// `features/repairs/enums.ts` and `features/contracts/enums.ts` established: the array is a
// literal tuple the filters and the form can iterate, and a member the contract adds or drops
// is a compile error in the PR that regenerated the client rather than a `<select>` that
// quietly stops offering a type.
//
// The order is FOUNDATION_BRIEF §3's own, which is also the order `EquipmentType` is declared
// in and the order the enum's numbers were assigned; `OTHER` stays last because it is the
// catch-all and a picker that offered it second would invite it.

import type { EquipmentType } from '@/client';

/** FOUNDATION_BRIEF §3 / 03 §11.4 — the installations a landlord keeps a register of. */
export const EQUIPMENT_TYPES = [
  'CENTRALA_TERMICA',
  'AC',
  'BOILER',
  'GAS_DETECTOR',
  'ELEVATOR',
  'APPLIANCE',
  'SOLAR_PANEL',
  'OTHER',
] as const satisfies readonly EquipmentType[];

/** Whether a string is one of the eight members — the calendar's title is a member or a name (D-2733). */
export function isEquipmentType(value: string): value is EquipmentType {
  return (EQUIPMENT_TYPES as readonly string[]).includes(value);
}
